import React, { ReactNode } from 'react';

import Newsletter from '@components/Newsletter';
import Footer from '@components/Footer';
import Navbar from '@components/Navbar';

type Props = {
  children: ReactNode;
  mainNavigation: MainNavigation;
  footerNavigation: FooterNavigation;
};
function Layout({ children, mainNavigation, footerNavigation }: Props) {
  console.log({ footerNavigation });
  return (
    <>
      <Navbar items={mainNavigation} />
      <main>
        {children}
        <Newsletter />
      </main>

      <Footer items={footerNavigation} />
    </>
  );
}

export default Layout;
